























import { Vue, Component, Prop } from 'vue-property-decorator';

const { AgGridVue } = require('ag-grid-vue');
import {
  GridOptions,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  ColDef,
  ColumnApi,
  CellClickedEvent,
} from 'ag-grid-community';

import { DetalleDispositivosApi } from '../models/BajasComerciales.model';

@Component({ components: { GridComponent: AgGridVue } })
export default class TabDetalle extends Vue {
  @Prop({ required: true, default: [] }) data!: DetalleDispositivosApi[];

  columnApi: any = null;
  gridOptions: GridOptions = null;
  gridEvent: any = null;
  gridApi: GridApi = null;
  columnDefs: ColDef[] = [];
  listData: any = [];
  quickSearch: string = '';

  constructor() {
    super();
    this.columnDefs = this.colsGrid();

    this.gridOptions = {
      columnDefs: this.columnDefs,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      overlayNoRowsTemplate: 'No hay filas para mostrar',
      onGridReady: this.handleMainGridReady,
    };
  }

  handleMainGridReady(event: GridReadyEvent): void {
    this.gridApi = event.api;
    this.columnApi = event.columnApi;
    this.gridEvent = event;
    this.gridApi.setRowData(this.data);
    this.gridApi.setDomLayout('autoHeight');
  }

  handleSearch() {
    this.gridApi.setQuickFilter(this.quickSearch);
    this.gridApi.setDomLayout('autoHeight');
  }

  private colsGrid(): ColDef[] {
    const fields = [
      'Nombre Línea',
      'EPC',
      'Nota de Venta',
      'Serie EP',
      'Produto ERP',
      'productos Comerciales',
      'Flota',
      'Telco',
      'Tipo de Flota',
      'Plataforma',
      'Movil',
      'Sim Card',
      'Estado',
      'Razon del Estado',
      'Tarifa Monitoreo',
      'Tarifa Roaming',
      'Tarifa Nube',
      'Tarifa Route Planner',
      'Tarifa Arriendo',
      'Tarifa Comodato',
      'Tarifa Sim Global',
      'Tarifa Peaje',
      'Tarifa Servicio Mantencion',
      'Tarifa Total',
    ];

    return Object.keys(this.data[0])
      .filter(col => !['id', 'id_baja_crm', 'TOTAL_REGISTROS'].includes(col))
      .map((col, i) => ({
        headerName: fields[i],
        field: col,
        cellStyle: { textAlign: 'left' },
        resizable: true,
        width: 220,
        minWidth: 100,
      }));
  }
}
